export const buttonClass = (className?: string) =>
  `dm__py-5 dm__px-11 dm__bg-gradient-to-r dm__from-[#DA77F2] dm__to-[#BE4BDB] dm__rounded-[33px] dm__text-2xl dm__text-white ${
    className ?? ""
  }`;
